import { AmortizacionReadingDtoProps } from "api/DTOs/AmortizacionReadingDto"
import { MovimientoBancarioReadingDtoProps } from "api/DTOs/MovimientoBancarioReadingDto"
import { withFormik } from "formik"
import * as Yup from "yup"
import AnnotationForm from "./form"

interface MapPropsToValue {
  data: MovimientoBancarioReadingDtoProps | AmortizacionReadingDtoProps | null
  onHide: () => void
  handleSubmitAnnotation: (values: { descripcion: string }) => void
}

const validationSchema = Yup.object().shape({
  descripcion: Yup.string(),
})

const NewAnnotationForm = withFormik({
  validateOnChange: true,
  validateOnBlur: true,
  mapPropsToValues: ({ data }: MapPropsToValue) => {
    return { descripcion: data?.nota || "" }
  },
  validationSchema,
  handleSubmit: async (values, { props }) => {
    props.handleSubmitAnnotation(values)
  },
})(AnnotationForm)

export default NewAnnotationForm
